import React from 'react';
import { getAvatarColors } from '../../../shared/misc/utils';

export interface TeamMember {
  imgPath?: string;
  name: string;
  initials: string;
}

interface Props {
  members: TeamMember[];
}

const AvatarGroup: React.FC<Props> = ({ members }) => {
  const renderMembers = () => {
    let tempAvatarColors = getAvatarColors();
    return members.map((member, i) => {
      const index = Math.floor(Math.random() * (tempAvatarColors.length - 1));
      const color = tempAvatarColors[index];
      tempAvatarColors = tempAvatarColors.filter((x, j) => j !== index);
      const renderMemberAvatar = member.imgPath ? (
        <img className="topbar__avatar-img" src={member.imgPath} alt={member.name} />
      ) : (
        <div className={`topbar__avatar-img ${color}`} title={member.name}>
          <span>{member.initials}</span>
        </div>
      );
      if (i < 5) {
        return (
          <div key={member.name} className="avatar_wrapper">
            {renderMemberAvatar}
          </div>
        );
      }
      return null;
    });
  };

  return <>{renderMembers()}</>;
};

export default AvatarGroup;
